class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    clearTimeout(this.closeTimer);
    this.closeTimer = null;
    this.detailsContainer.classList.remove('zippopiu-search-closing');
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (this.closeTimer) return;
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);

    const finishClose = () => {
      this.detailsContainer.removeAttribute('open');
      this.detailsContainer.classList.remove('zippopiu-search-closing');
      document.body.classList.remove('overflow-hidden');
      this.closeTimer = null;
    };
    const animate = this.classList.contains('header__search') &&
      window.matchMedia('(max-width: 749px) and (prefers-reduced-motion: no-preference)').matches;
    if (!animate) {
      finishClose();
      return;
    }
    this.detailsContainer.classList.add('zippopiu-search-closing');
    this.closeTimer = setTimeout(finishClose, 200);
  }
}

customElements.define('details-modal', DetailsModal);
